import React from 'react'
import {Field} from 'redux-form'

const ApplePayForm = props => {

	return (
		<div>
			<h4>Apple Pay:</h4>
			<div className="form-group">
				<label htmlFor="merchantIdentifier">Merchant Identifier*</label>
				<Field className="form-control" name="applepay.merchantIdentifier" component="input" type="text"/>
			</div>

			<div className="form-group">
				<label htmlFor="displayName">Display name*</label>
				<Field className="form-control" name="applepay.displayName" component="input" type="text"/>
			</div>

			<div className="form-group">
				<label htmlFor="countryCode">Country code*</label>
				<Field className="form-control" name="applepay.countryCode" component="input" type="text"/>
			</div>

			<div className="form-group">
				<label htmlFor="domainName">
          Merchant validation URL <br />
          <small>(This field is only for testing purpose. It is not send to the widget! This field is used by the widget testing tool where we simulate merchant validation!)</small>
        </label>
				<Field className="form-control" name="applepay.validateMerchantUrl" component="input" type="text"/>
			</div>

			<div className="form-group">
        <div className="checkbox">
          <label>
            <Field component="input" name="applepay.useBillingAndShipping" type="checkbox"/> <b>Use billing and shipping addresses from Apple Pay</b>
          </label>
        </div>
      </div>

			<div className="form-group">
				<div className="checkbox">
					<label>
						<Field component="input" name="applepay.applepayCallbacks" type="checkbox"/> <b>Use callbacks</b>
					</label>
				</div>
			</div>
		</div>
	);
}

export default ApplePayForm;



// WEBPACK FOOTER //
// ./src/modal/products/ApplePayForm.js